module.exports = __webpack_public_path__ + "static/media/loading.0c69e442.gif";